module.exports = __webpack_public_path__ + "img/fblogo.1c224fb7.png";